import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { CustomEase } from "gsap/CustomEase";
import { animationLoader } from "./animationLoader";
import { unLazyLoad } from "./unlazyLoad";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { LDScrollTo } from "./scrollTo.js";
import { slideDown, slideUp } from "./slideupSlidedown.js";
import { LD_Custom_Eases } from "./customEases";
import { newElement } from "./newElement.js";
import { tapEvent, TapHandler } from "./tapCapture";

gsap.registerPlugin( Flip, ScrollTrigger, Observer, ScrollToPlugin, CustomEase );

// Establish Custom Eases
const ce = new LD_Custom_Eases();
let isTap = false;

function clearGsapProps( element, classToAdd = '' ) {
	gsap.to( element, {
		clearProps: true,
		onComplete: function() {
			if( classToAdd !== '' ) {
				element.classList.add( classToAdd );
			}
		}
	});
}

function animateNavigation( menuObj ) {
  const html = document.querySelector('html');

  // Main Mobile Nav
  if ( false === menuObj.classList.contains( 'sub-menu' ) ) {
    
    if ( false === menuObj.classList.contains( 'active' ) ) {
      
      html.style.overflow = null;
      
      gsap.to( menuObj, {
        opacity: 1,
        x: "200vw",
        duration: 0.3,
        ease: 'exiting',
        onComplete: function () {
					clearGsapProps( menuObj );
        }
      } );

    }
    else {
      html.style.overflow = "hidden";
      
      gsap.fromTo( menuObj, {
        // display: 'block',
				display: 'var(--original-display)',
        duration: 0.001,
        opacity: 1,
        x: "200vw",
      }, {
        opacity: 1,
        x: "0vw",
        duration: 0.5,
        ease: 'entering',
				onComplete: function () {
					// an element with a position:fixed will not remain fixed if
					// its parent has a transform property set. 
					// in order for the ::before element to show correctly,
					// we must set the transform of the nav element to null.
					menuObj.style.transform = null;
				}
      });
    }
  }
  // Sub Menus
  else {
    if ( false === menuObj.classList.contains( 'active' ) ) {
      slideUp( menuObj, 0.2 );
    }
    else {
      slideDown( menuObj, 0.3 );
    }
  }
}

// // Element variables
// const menuToggle = document.querySelector('.menu-toggle');
// const navMenu = document.querySelector('.nav-menu[role="navigation"]');

const elementExists = function(element) {
	if ( typeof(element) != 'undefined' && element != null ) {
		return true;
	}
	return false;
}

// // Event functions
// const toggleMenu = function(event) {
// 	if ( !event.target.closest('.menu-toggle') ) return;
// 	if ( elementExists(navMenu) ) {
// 		navMenu.classList.toggle('active');
// 		animateNavigation( navMenu );
// 	}
// 	menuToggle.classList.toggle('active');	
// }

// const toggleSubMenu = function(event) {
// 	if ( !event.target.closest('.submenu-expand') ) return;
// 	event.target.closest('.submenu-expand').classList.toggle('expanded');
// 	event.preventDefault();
// }

// // Add functions to click event listener
// document.addEventListener('click', function(event) {
// 	toggleMenu(event);
// 	toggleSubMenu(event);
// });

let ageGate = false;
// Age Gate
window.addEventListener( 'age_gate_shown', ()=> {
	ageGate = true;
});


document.addEventListener( "DOMContentLoaded", () => {
	// Intro
	// const shadeLoadingAnimation = document.querySelector('#eZK2Ow8E1l91');
	const shadeLoadingAnimation = document.querySelector('.loading-shade svg');
	// const ageVerifyTrigger = document.querySelector('button.pum-age-enter');
	// let hasAgeCookie = ageCookiePresent();
	
	if( null !== shadeLoadingAnimation ) {
		const loadingShade = document.querySelector('.loading-shade');
		const headerID = document.querySelector('.site-id-wrap');
		const headerIdA = document.querySelector('.site-id-wrap a');
		const animationContainer = loadingShade.querySelector('.loading-animation');
		const loadingBackground = loadingShade.querySelector('.background');
		const headerIdLocation = {
			x: headerID.offsetTop,
			y: headerID.offsetLeft,
			w: headerID.offsetWidth,
			h: headerID.offsetHeight
		};

		let svgPlayer = shadeLoadingAnimation.svgatorPlayer;
		while ( svgPlayer === undefined ) {
			svgPlayer = shadeLoadingAnimation.svgatorPlayer;
		}


		// console.log("🚀 ~ hasAgeCookie:", hasAgeCookie)
		// console.log("🚀 ~ ageVerifyTrigger:", ageVerifyTrigger)
		// console.log("🚀 ~ ageGate:", ageGate );

		
		if( ageGate ) {
			svgPlayer.stop();

			window.addEventListener( 'age_gate_passed', ()=> {
				svgPlayer.play();
			});
		} else {
			svgPlayer.ready( player => player.play() );
		}


		// if( ! hasAgeCookie ) {
		// 	svgPlayer.stop();

		// 	if( null === ageVerifyTrigger ) {
		// 		svgPlayer.play();
		// 	}
		// 	else {
		// 		ageVerifyTrigger.addEventListener('click', ()=>{
		// 			svgPlayer.play();
		// 		});
		// 	}
		// } else {
		// 	svgPlayer.ready( player => player.play() );
		// }

		let shadeTl = gsap.timeline( {
			paused: true
		});
		gsap.set( animationContainer, {
			position: 'absolute',
			top: animationContainer.offsetTop,
			left: animationContainer.offsetLeft
		});
		shadeTl.to( animationContainer, {
			duration: 0.5,
			ease: "standard",
			top: headerIdLocation.x,
			left: headerIdLocation.y,
			height: headerIdLocation.h,
			width: headerIdLocation.w
		});
		shadeTl.to( loadingBackground, {
			delay: 0.5,
			duration: 0.3,
			ease: "exiting",
			y: "-100vh",
			// opacity: 0.5,
			// onComplete: function() {
			// 	loadingShade.remove();
			// }
		});
		shadeTl.to( animationContainer, {
			opacity: 0,
			duration: 0.2,
			onComplete: function() {
				loadingShade.remove();
			}
		}, ">");

		svgPlayer.on( 'end', () => {
			shadeTl.play();
		});

	}

	// Navigation
	const menuToggle = document.querySelector('.menu-toggle');
	const navMenu = document.querySelector('.nav-menu[role="navigation"]:has(#primary-menu)');
	const menuItemsHaveChildren = navMenu.querySelectorAll('.menu-item-has-children');
	new TapHandler('.menu-item-has-children > a');
	
	menuToggle.addEventListener('click', () => {
		if ( elementExists(navMenu) ) {
			navMenu.classList.toggle('active');
			animateNavigation( navMenu );
		}
		menuToggle.classList.toggle('active');	
	});

	if( menuItemsHaveChildren.length > 0 ) {
		let passedCenter = false;
		menuItemsHaveChildren.forEach( thisMenuItem => {
			const toggleButton = thisMenuItem.querySelector('button');
			const aLink = thisMenuItem.querySelector('a');
			const subMenu = thisMenuItem.querySelector('.sub-menu');

			if( thisMenuItem.classList.contains('split') ) {
				passedCenter = true;
			}

			if( passedCenter ) {
				subMenu.classList.add('align-right');
			}
			if( thisMenuItem.classList.contains('admin-menu') ) {
				const thisLink = thisMenuItem.querySelector('a');
				thisLink.innerHTML = `<i class="fa-solid fa-gear"></i><span>${thisLink.innerHTML}</span>`;
			}
			thisMenuItem.addEventListener('tap', event => {
				isTap = true;
				if( thisMenuItem.classList.contains('active') ) {
					toggleButton.setAttribute('aria-expanded', 'false' );
					aLink.setAttribute('aria-expanded', 'false' );
				}
				else {
					toggleButton.setAttribute('aria-expanded', 'true' );
					aLink.setAttribute('aria-expanded', 'true' );

					thisMenuItem.classList.toggle('active');
					toggleButton.classList.toggle('expanded');
				}
			});
			aLink.addEventListener('click', event => {
				if( isTap ){
					isTap = false;
					if( aLink.getAttribute('aria-expanded') === 'true' ){
						event.preventDefault();
					}
				}
			});

			toggleButton.addEventListener('click', event => {
				if( thisMenuItem.classList.contains('active') ) {
					toggleButton.setAttribute('aria-expanded', 'false' );
					aLink.setAttribute('aria-expanded', 'false' );
				}
				else {
					toggleButton.setAttribute('aria-expanded', 'true' );
					aLink.setAttribute('aria-expanded', 'true' );
				}
				thisMenuItem.classList.toggle('active');
				toggleButton.classList.toggle('expanded');
			});
		});
	}

	// Slide-in sections
	const slideIns = document.querySelectorAll('.is-style-slide-in-from-left');

	if( slideIns.length > 0 ){
		const aniLoad = new animationLoader('.is-style-slide-in-from-left', { threshold: 0.1 });
		slideIns.forEach( thisImg => {
			let slideTl = gsap.timeline({
				paused: true,
				ease: "entering"
			});

			gsap.set( thisImg, {
				xPercent: -50
			});

			slideTl.to( thisImg, {
				xPercent: 0,
				duration: 0.8,
				onComplete: function() {
					thisImg.classList.add('complete');
				}
			});

			thisImg.addEventListener("aniActive", () => {
				slideTl.play();
			});

		});
	}

	const entryHeader = document.querySelector('.entry-header:has(.entry-header-image) > .entry-title');
	const entryImage = document.querySelector('.entry-header > .entry-header-image > img');
	
	if( null !== entryHeader && null !== entryImage ){
		// console.log( "here!" );
		// const aniLoad = new animationLoader('.entry-header:has(.entry-header-image) > .entry-title', { threshold: 0 });

		let titleSpan = newElement( 'span', false );
		titleSpan.innerHTML = entryHeader.innerHTML;
		entryHeader.innerHTML = '';
		entryHeader.append( titleSpan );

		let entryHeaderTL = gsap.timeline({
			paused: true,
			delay: 0.3,
			ease: "entering"
		});

		gsap.set( titleSpan, {
			xPercent: -50
		});

		entryHeaderTL.to( entryImage, {
			duration: 0.15,
			opacity: 1,
		}).to( entryImage, {
			duration: 0.2,
			filter: 'blur(0px)',
		}, ">" ).to( entryHeader, {
			xPercent: 80,
			opacity: 1,
			duration: 0.3,
			onComplete: function () {
				clearGsapProps( entryHeader, 'ani-done' );
			}
		}, "<" ).to( titleSpan, {
			xPercent: 0,
			duration: 0.5,
			ease: "elastic.out(1,1)",
			onComplete: function () {
				clearGsapProps( titleSpan );
			}
		}, "<+0.2" );

		// entryHeader.addEventListener("aniActive", () => {
		// 	entryHeaderTL.play();
		// });
		window.addEventListener("load", () => {
			// console.log("playing");
			entryHeaderTL.play();
		});

	}

	// Animated covers
	const fadeIns = document.querySelectorAll('.is-style-fade-in');

	/*
		@keyframes fadein-cover {
		0% {
			transform: scale( 110% );
			opacity: 0;
			filter: blur(10px);
		}
		100% {
			transform: scale( 100% );
			opacity: 1;
			opacity: var(--initial-opacity);
			filter: blur(0);
		}
	}
*/

	if( fadeIns.length > 0 ){
		const fadeInAniLoad = new animationLoader('.is-style-fade-in', { threshold: 0.3 });
		
		fadeIns.forEach( thisFade => {
			let finalOpacity = 0.5;
			const backgroundElement = thisFade.querySelector('.wp-block-cover__background');
			const contentElement = thisFade.querySelector('.wp-block-cover__inner-container');
			const initOpacity = backgroundElement.getAttribute('class').match(/has-background-dim-(\d{1,2})/);
			
			if( initOpacity !== null ) {
				finalOpacity = initOpacity[1] / 100;
			}

			gsap.set( [contentElement, backgroundElement], {
				scale: 1.1,
				opacity: 0,
				filter: "blur(10px)"
			});

			let fadeTL = gsap.timeline({
				duration: 0.2,
				ease: "entering",
				paused: true
			});

			fadeTL.to( backgroundElement, {
				scale: 1,
				opacity: finalOpacity,
				filter: "blur(0px)",
				delay: 0.1
			}).to( contentElement, {
				scale: 1,
				opacity: 1,
				filter: "blur(0px)",
				delay: 0.2
			});

			thisFade.addEventListener("aniActive", () => {
				fadeTL.play();
			});
		});
	}

});

// The following components add their own event listeners.
unLazyLoad();
const aniLoad = new animationLoader();
const scroller = new LDScrollTo();